import * as React from "react";
const SvgSalesforce = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Salesforce_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00A1E0",
  fillRule: "evenodd",
  d: "M9.965 5.835A4.2 4.2 0 0 1 13.01 4.53c1.589 0 2.965.883 3.706 2.197a5.1 5.1 0 0 1 2.092-.445c2.858 0 5.179 2.338 5.179 5.223 0 2.886-2.32 5.224-5.18 5.224q-.524 0-1.023-.102a3.79 3.79 0 0 1-3.3 1.942 3.8 3.8 0 0 1-1.659-.382 4.313 4.313 0 0 1-8.02-.194 4 4 0 0 1-.825.086c-2.214 0-4.005-1.817-4.005-4.05 0-1.5.806-2.806 2.003-3.512A4.662 4.662 0 0 1 6.26 4.004c1.508 0 2.858.72 3.705 1.836",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Salesforce_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgSalesforce;
//# sourceMappingURL=Salesforce.js.map